import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

import { makeIsReloadAboutWholeHome } from '../../../redux/selectors/homepageSelector';
import { useSelector } from '../../../redux/utils';

export default (callback: EffectCallback, deps: DependencyList) => {
  const isHomePageReload = useSelector(makeIsReloadAboutWholeHome());
  const isHomePageReloadPrev = useRef(isHomePageReload);

  useEffect(() => {
    if (!isHomePageReloadPrev.current && isHomePageReload) {
      callback();
    }

    isHomePageReloadPrev.current = isHomePageReload;
  }, [isHomePageReload, callback, ...deps]);
};
